<template>
  <div>
    <chart-container
      slot="raw-body"
      :chartData="chartData"
      :chartType="'ChartReport'"
      :heading="'Kursentwicklung Produkt vs. Basiswert (' + startDate + ' - ' + endDate + ')'"
      :settings="{
          style: {
            width: 680,
            height: 200
          }
        }"
    ></chart-container>

    <div slot="raw-body">
      <table class="table is-narrow table-report-development">
        <thead>
        <tr>
          <th></th>
          <th>Kaufkurs</th>
          <th>aktueller Kurs <br>
            <span v-if="['QTR0','QTRP'].includes(product.product.type)">(clean)</span>
          </th>
          <th>Kursentwicklung <br>
            <span v-if="['QTR0','QTRP'].includes(product.product.type)">(inkl. Stückzinsen)</span>
          </th>
          <th>Ausschüttung <br> (Nennbetrag)
          </th>
          <th>Ausschüttung <br> (Kaufkurs)
          </th>
          <th>Gesamt</th>
        </tr>
        </thead>
        <tbody>
        <tr class="field underlying">
          <td>
            <strong>Basiswert</strong>
          </td>
          <td>
            <tablefield-currency
              :config="{decoratorOptions: {currencyPath: 'added.underlyingQuotedAs'}}"
              :data="_.get(product, 'tradingFigures.underlyingPrice.useAsk')"
              :product="product"
            ></tablefield-currency>
          </td>
          <td>
            <tablefield-currency
              :config="{decoratorOptions: {currencyPath: 'added.underlyingQuotedAs'}}"
              :data="_.get(product, 'product.figures.underlyingPrice.useBid')"
              :product="product"
            ></tablefield-currency>
          </td>
          <td>
            <tablefield-percent
              :data="_.get(product, 'added.development.quote.underlying')"
            ></tablefield-percent>
          </td>
          <td>
            <tablefield-currency
              :data="_.get(product, 'added.development.payout.underlying.complete')"
              :product="product"
            ></tablefield-currency>
          </td>
          <td>
            <tablefield-percent
              :data="_.get(product, 'added.development.payout.underlying.quote')"
            ></tablefield-percent>
          </td>
          <td>
            <tablefield-percent
              :data="_.get(product, 'added.development.sum.underlying')"
            ></tablefield-percent>
          </td>
        </tr>
        <tr class="field product">
          <td>
            <strong>Produkt</strong>
          </td>
          <td>
            <tablefield-currency
              :config="{decoratorOptions: {currencyPath: 'added.productQuotedAs'}}"
              :data="_.get(product, 'tradingFigures.productPrice.useAsk')"
              :product="product"
            ></tablefield-currency>
          </td>
          <td>
            <tablefield-currency
              :config="{decoratorOptions: {currencyPath: 'added.productQuotedAs'}}"
              :data="_.get(product, 'product.figures.productPrice.useBid')"
              :product="product"
            ></tablefield-currency>
          </td>
          <td>
            <tablefield-percent
              :data="_.get(product, 'added.development.quote.product')"
            ></tablefield-percent>
          </td>
          <td>
            <tablefield-currency
              :data="_.get(product, 'added.development.payout.product.notional')"
              :product="product"
            ></tablefield-currency>
          </td>
          <td>
            <tablefield-percent
              :data="_.get(product, 'added.development.payout.product.quote')"
            ></tablefield-percent>
          </td>
          <td>
            <tablefield-percent
              :data="_.get(product, 'added.development.sum.product')"
            ></tablefield-percent>
          </td>
        </tr>
        </tbody>
      </table>

    </div>

  </div>
</template>

<script>
import FieldMixin from '../table-field/FieldMixin.vue'
import ChartContainer from "../chart/ChartContainer.vue"


export default {
  name: 'report-development',
  mixins: [FieldMixin],
  props: {
    product: {
      type: Object,
      required: true
    },
    chartData: {
      type: Object,
      required: true
    }
  },
  components: {
    ChartContainer
  },
  computed: {
    startDate() {
      return this.moment(this.chartData.labels[0]).format('DD.MM.YY')
    },
    endDate() {
      return this.moment(this.chartData.labels[this.chartData.labels.length - 1]).format('DD.MM.YY')
    }
  }
}

</script>



// WEBPACK FOOTER //
// ReportDevelopment.vue?daca159c